var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',_vm._b({attrs:{"effect":_vm.effect,"tabindex":-1}},'el-tooltip',_vm.$attrs,false),[_c('template',{slot:"content"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.content))]})],2),_c('i',{class:_vm.icon || 'el-icon-' + _vm.type})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }